import React from "react";
import { Building, Check, Radio } from "lucide-react";
import FollowFeed from "./FollowFeed";

// Phase 2.5.3a (UX revision) — the "Following" surface only. The standalone "Follow a business"
// grid was removed; following now happens via the inline Follow pill on each business-browse card
// (App.jsx / BusinessChannelCard). State comes from the shared useConsumerFollows hook, instantiated
// once in App and passed down, so the pills and this list never drift. Never touches playback.
const SCOPES = [
  { key: "all", label: "All" },
  { key: "announcements", label: "News" },
  { key: "offers", label: "Offers" },
];

export default function FollowBusinesses({ following = [], feed = [], onToggle, onSetScope, busy, signedIn }) {
  if (!signedIn || following.length === 0) return null;

  return (
    <section className="mb-14">
      <div className="mb-6"><h2 className="text-xl font-semibold tracking-tight">Following</h2>
        <p className="text-white/30 text-sm mt-1">Businesses you follow — their channels &amp; what they send you</p></div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {following.map((b) => (
          <div key={b.company_id} className="bg-white/[0.03] rounded-2xl p-4 border border-white/[0.06]">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2"><Building size={16} strokeWidth={1.5} className="text-white/40" />
                <span className="font-semibold text-sm">{b.business_name}</span></div>
              <button onClick={() => onToggle(b.company_id)} disabled={busy === b.company_id}
                className="text-xs px-3 py-1 rounded-full border border-white/20 text-white/60 hover:text-white transition flex items-center gap-1">
                <Check size={12} />Following</button>
            </div>
            <div className="space-y-1 mb-3">
              {b.channels.length
                ? b.channels.map((c) => (
                    <div key={c.id} className="flex items-center gap-2 text-sm text-white/50"><Radio size={12} strokeWidth={1.5} />{c.name}</div>
                  ))
                : <p className="text-white/30 text-xs">No public channels right now</p>}
            </div>
            {/* 2.5.3b: per-business delivery scope (channels always stay visible; this governs pushed content only) */}
            <div className="flex items-center gap-1 pt-2 border-t border-white/[0.06]">
              <span className="text-white/25 text-[10px] uppercase tracking-wider mr-1">Send me</span>
              {SCOPES.map((s) => {
                const active = (b.scope || "all") === s.key;
                return (
                  <button key={s.key} onClick={() => !active && onSetScope && onSetScope(b.company_id, s.key)}
                    className={`text-[11px] px-2.5 py-1 rounded-full transition ${active ? "bg-white text-black" : "bg-white/[0.06] text-white/50 hover:text-white/80"}`}>
                    {s.label}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      {/* 2.5.3b feed nested under the SAME "Following" header (one header block, no redundant section). */}
      {feed.length > 0 && (
        <div className="mt-8">
          <h3 className="text-white/45 text-xs font-semibold uppercase tracking-wider mb-4">Latest from your businesses</h3>
          <FollowFeed feed={feed} />
        </div>
      )}
    </section>
  );
}
